import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../Autocomplete';
import { coupons as couponsApi } from '@afosto/order/api/Coupons';

const CouponCategorySearch = ({ scopes, ...props }) => {
  const [couponCategorySuggestions, setCouponCategorySuggestions] = useState([]);
  const [isFetchingCouponCategories, setIsFetchingCouponCategories] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchAllCouponCategories = async () => {
      setIsFetchingCouponCategories(true);

      try {
        const response = await couponsApi.getCouponCategories();
        const { data: couponCategories = [] } = response;

        if (isMounted) {
          setCouponCategorySuggestions(
            couponCategories.map(category => ({
              ...category,
              label: category.name,
              value: category.id,
            })),
          );
        }
      } catch (err) {
        if (isMounted) {
          setCouponCategorySuggestions([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingCouponCategories(false);
        }
      }
    };

    fetchAllCouponCategories();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Autocomplete
      {...props}
      options={couponCategorySuggestions}
      loading={isFetchingCouponCategories}
      autocomplete="off"
    />
  );
};

CouponCategorySearch.propTypes = {
  ...Autocomplete.propTypes,
  scopes: PropTypes.array,
};

CouponCategorySearch.defaultProps = {
  ...Autocomplete.defaultProps,
  scopes: [],
};

export default CouponCategorySearch;
